module.exports = __webpack_public_path__ + "static/the-new-jim-crow-8e9baf9816b2000966a0c61bfddf7512.jpg";